// Shared bits for the call-flow editor sub-forms.

export const inputCls = 'w-full px-2.5 py-1.5 text-sm border border-gray-200 rounded focus:outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-500';
export const labelCls = 'block text-xs font-medium text-gray-700 mb-1';
export const smallBtnCls = 'text-xs text-purple-700 hover:underline flex items-center gap-1';

/** Number inputs let '1e5' or pasted negatives through — clamp to the same
 *  bounds the backend validator enforces. */
export function clampInt(raw: string, max: number, min = 0): number | undefined {
  if (raw === '') return undefined;
  const n = Math.round(Number(raw));
  if (!Number.isFinite(n)) return undefined;
  return Math.max(min, Math.min(max, n));
}
